import { CikisiClientRef } from './admin-overview.model';

/** One row of GET /admin/organizations. Also reused, unchanged, as
 *  top_organizations[].organization on Overview and organization.* on an
 *  Organization Detail page (a superset AdminOrganizationDetailOrg
 *  extends this) same object, three places it shows up. */
export class AdminOrganizationRow {
  id!: number;
  name!: string;
  slug!: string;
  billingExempt!: boolean;
  focus!: boolean;
  cikisiClient: CikisiClientRef | null = null;
  balanceCents!: number;
  currency!: string;
  createdAt!: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.slug = data.slug;
    this.billingExempt = !!data.billing_exempt;
    this.focus = !!data.focus;
    this.cikisiClient = data.cikisi_client ?? null;
    this.balanceCents = data.balance_cents;
    this.currency = data.currency;
    this.createdAt = data.created_at;
  }
}

/** `totals` on GET /admin/organizations: the whole filtered list, not the page.
 *  Null on the response until the backend ships it (the card stays hidden). */
export class AdminOrganizationTotals {
  organizations!: number;
  billingExempt!: number;
  focus!: number;
  balanceCents!: number;
  negativeBalances!: number;
  currency!: string;

  constructor(data: any = {}) {
    this.organizations = data.organizations ?? 0;
    this.billingExempt = data.billing_exempt ?? 0;
    this.focus = data.focus ?? 0;
    this.balanceCents = data.balance_cents ?? 0;
    this.negativeBalances = data.negative_balances ?? 0;
    this.currency = data.currency ?? 'eur';
  }

  get billed(): number {
    return this.organizations - this.billingExempt;
  }
}
